import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";
import { faArrowToBottom } from "@fortawesome/pro-regular-svg-icons";
import { faArrowFromRight, faArrowToRight, faCog, faTable } from "@fortawesome/pro-light-svg-icons";
import classNames from "classnames";
import styled from "styled-components";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExportDisabled } from "extensions/fa5-icons/faExportDisabled";

import { store } from "common/store";

import { Tooltip } from "common/components/tooltip";
import { pazienHistory } from "common/components/pazienHistory";
import { Placeholder } from "common/components/placeholder";

export function ExportWarningMessage({ millionRows }) {
    if (!millionRows) return null;
    
    return (
        <ExportWarning>
            <div className="alert-warning">
                <FontAwesomeIcon className="triangle-icon" icon={faExportDisabled}/>
                <div className="info-message">
                    Export is limited to 1 million rows. Condense your data, or check out schedule delivered reports options (SDR) options. <button type="button" className="btn" onClick={() => { pazienHistory.navigateWithParams("support", { trigger: true }); }}>Learn more about SDR</button>
                </div>
            </div>
        </ExportWarning>
    );
}

export function TableControls(props) {
    if (props.loading) {
        return (
            <TableControlsBar>
                {props.paginatorTop && props.paginator && <Placeholder size="medium"/>}
                <Placeholder size="medium" className="controls-bar"/>
            </TableControlsBar>
        );
    }
    
    return (
        <TableControlsBar>
            {props.paginatorTop && props.paginator}
            
            <div className="controls-bar">
                {props.showConfigButton && (
                    <TableControlIcon>
                        <Tooltip title="Configure table">
                            <FontAwesomeIcon onClick={props.showConfig} icon={faCog}/>
                        </Tooltip>
                    </TableControlIcon>
                )}
                {props.showCollapsedToggle && (
                    <TableControlIcon>
                        <Tooltip title={props.expanded ? "Click to collapse table columns" : "Click to expand table columns"}>
                            <div className={`expanded-view-toggle ${props.expanded}`} onClick={props.toggleView}>
                                <FontAwesomeIcon icon={faTable} className="table-icon"/>
                                {props.expanded && <FontAwesomeIcon icon={faCheckCircle} className="toggle-on"/>}
                                {props.expanded
                                    ? <FontAwesomeIcon icon={faArrowFromRight} className="arrow-icon arrow"/>
                                    : <FontAwesomeIcon icon={faArrowToRight} className="arrow-icon arrow"/>}
                            </div>
                        </Tooltip>
                    </TableControlIcon>
                )}
                {store.getState().permissions.user_permissions.feature_export && props.showExportButton && (
                    <TableControlIcon className={classNames({ disabled: (props.millionRows || props.disableToolbar) })} onClick={!props.millionRows && !props.disableToolbar ? props.export : void 0}>
                        <Tooltip title="Export transactions">
                            <FontAwesomeIcon className="export" icon={props.millionRows ? faExportDisabled : faArrowToBottom}/>
                        </Tooltip>
                    </TableControlIcon>
                )}
            </div>
        </TableControlsBar>
    );
}

const ExportWarning = styled.div`
    padding: 0;
    margin: 0;

    .alert-warning {
        display: flex;
        flex: 0 0 auto;
        justify-content: center;
        align-items: center;
        margin-bottom: 10px;
        background: ${(props) => props.theme.colors.red};
        color: ${(props) => props.theme.colors["canvas-white"]};
        border: 0;
        border-radius: 4px;
        padding: 7px;
        text-align: center;


        .triangle-icon {
            display: inline-block;
            position: relative;
            font-size: 20px;
            margin-right: 10px;
            flex-shrink: 0;
        }

        .info-message {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;

            .btn {
                background: ${(props) => props.theme.colors["canvas-white"]};
                opacity: 0.8;
                color: ${(props) => props.theme.colors.red};
                padding: 2px 6px;
                margin-left: 10px;
                outline: none;
                border-radius: 4px;

                &:hover {
                    opacity: 1;
                }
            }
        }
    }
`;

const TableControlsBar = styled.div`
    display: flex;
    flex: 0 0 auto;
    flex-direction: row;
    align-items: flex-end;
    margin: 5px 0;

    .controls-bar {
        display: flex;
        margin-left: auto;
        flex: 0 0 auto;
        flex-direction: row;
        color: ${(props) => props.theme.colors["gray-light"]};
        font-size: 24px;

        .expanded-view-toggle {
            position: relative;

            &.true {
                color: ${(props) => props.theme.colors["blue-light"]};
            }

            .toggle-on {
                position: absolute;
                left: 20px;
                top: 20px;
                z-index: 9;
                padding: 1px;
                font-size: 14px !important;
                color: ${(props) => props.theme.colors["green-leaf"]};
                background: ${(props) => props.theme.colors["canvas-white"]};
                border-radius: 50%;
            }

            .arrow-icon {
                font-size: 16px !important;
                transform: translate(20%, -30%);
            }
        }
    }
`;

const TableControlIcon = styled.div`
    display: flex;
    flex: 0 0 auto;
    justify-content: center;
    align-items: center;
    margin: 0 12px;
    cursor: pointer;
    &.disabled {
        color: ${(props) => props.theme.colors["grey-wcag-6B6"]}60 !important;
    }
    &:hover {
        color: ${(props) => props.theme.colors["blue-wcag-327"]};

        &.disabled {
            color: ${(props) => props.theme.colors["grey-wcag-6B6"]}60 !important;
            cursor: not-allowed;
        }
    }
`;
